
import ProductChangelog from "@/types/ProductChangelog";
import dayjs from "dayjs";
import { computed, defineComponent, PropType, ref } from "vue";
import { Link } from "@inertiajs/inertia-vue3";

const fields = {
  varenr_supplier: "Varenr (Leverandør)",
  varenr_producer: "Varenr (Produsent)",
  description: "Beskrivelse",
  category: "Kategori",
  supplier: "Leverandør",
  name: "Navn",
  price: "Pris eks. mva",
  mva_percent: "MVA sats",
  auto_rebate: "Automatisk kunderabatt",
  quantity_discount_amount: "Kvantumsrabatt mengde",
  quantity_discount_price: "Kvantumsrabatt pris",
  cost: "Innpris",
  stock: "Lagerstatus",
  stock_minimum: "Minimum lagerstatus",
  unit: "Produktenhet",
  weight: "Vekt",
  shipping_separate: "Sendes individuelt (eget kolli)",
  dimension_length: "Lengde",
  dimension_width: "Bredde",
  dimension_height: "Høyde",
  barcode: "Strekkode",
  extra_barcode: "Strekkode 2",
  web_view: "Vises i nettbutikk",
  can_ship: "Kan sendes (ikke fordærvelig)",
  featured: "Fremhevet webvare",
  out_of_production: "Utgått vare",
  structural: "Strukturvare",
  is_pant_product: "Er panttype",
  is_outlet: "I Billigkroken",
};

export default defineComponent({
  components: {
    Link,
  },
  props: {
    changelog: {
      type: Object as PropType<ProductChangelog>,
      required: true,
    },
  },
  setup(props) {
    const date = computed(() => {
      return dayjs(props.changelog.created_at).format("DD.MM.YY HH:mm");
    });

    // @ts-ignore
    const fieldName = computed(() => fields[props.changelog.field]);

    const showAllContent = ref(false);

    const defaultLength = 300;

    const valueFrom = computed(() => {
      if (!showAllContent.value) {
        return props.changelog.value_from?.slice(0, defaultLength);
      }

      return props.changelog.value_from;
    });

    const valueTo = computed(() => {
      if (!showAllContent.value) {
        return props.changelog.value_to?.slice(0, defaultLength);
      }

      return props.changelog.value_to;
    });

    const fromHasMoreContent = computed(() => {
      const length = props.changelog.value_from?.length ?? 0;

      return !showAllContent.value && length > defaultLength;
    });

    const toHasMoreContent = computed(() => {
      const length = props.changelog.value_from?.length ?? 0;

      return !showAllContent.value && length > defaultLength;
    });

    return {
      date,
      valueFrom,
      valueTo,
      fieldName,
      showAllContent,
      fromHasMoreContent,
      toHasMoreContent,
    };
  },
});
